import {
  adminClient,
  inferAdditionalFields,
  magicLinkClient,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { AdminAuth } from "./config";
import { getAuthBaseURL } from "../shared/client-helpers";

export function createAdminAuthClient(
  adminUrl?: string,
  options?: { forceBaseURL?: boolean }
) {
  return createAuthClient({
    baseURL: options?.forceBaseURL && adminUrl ? adminUrl : getAuthBaseURL(adminUrl),
    basePath: "/api/auth/admin",
    plugins: [
      organizationClient(),
      adminClient(),
      magicLinkClient(),
      inferAdditionalFields<AdminAuth>(),
    ],
  });
}

export type AdminAuthClient = ReturnType<typeof createAdminAuthClient>;
export type AdminAuthSession = AdminAuthClient["$Infer"]["Session"];
